import { render, staticRenderFns } from "./AddCustomerInformation.vue?vue&type=template&id=bc18c820&scoped=true&"
import script from "./AddCustomerInformation.vue?vue&type=script&lang=js&"
export * from "./AddCustomerInformation.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerInformation.vue?vue&type=style&index=0&id=bc18c820&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc18c820",
  null
  
)

export default component.exports